import { useEffect } from 'react';

const STORAGE_KEY = 'ai-qb-saved-ids';
const HIGHLIGHT_CLASS = 'ai-qb-highlight';
const FADE_CLASS = 'ai-qb-highlight-fade';

const useHighlightNewQuestions = () => {
  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return;

    sessionStorage.removeItem(STORAGE_KEY);

    let questionIDs: number[];
    try {
      questionIDs = JSON.parse(stored);
    } catch {
      return;
    }

    if (!questionIDs?.length) return;

    const elements = questionIDs
      .map(id => document.getElementById(`question_${id}`))
      .filter(Boolean) as HTMLElement[];

    if (!elements.length) return;

    elements.forEach(el => el.classList.add(HIGHLIGHT_CLASS));

    elements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });

    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (elements.some(el => el.contains(target))) return;

      elements.forEach((el) => {
        el.addEventListener('transitionend', () => {
          el.classList.remove(HIGHLIGHT_CLASS, FADE_CLASS);
        }, { once: true });
        el.classList.add(FADE_CLASS);
      });

      document.removeEventListener('click', handleClick);
    };

    requestAnimationFrame(() => {
      document.addEventListener('click', handleClick);
    });

    return () => {
      document.removeEventListener('click', handleClick);
      elements.forEach(el => el.classList.remove(HIGHLIGHT_CLASS, FADE_CLASS));
    };
  }, []);
};

export default useHighlightNewQuestions;
